import { render, staticRenderFns } from "./VoteRecognitionsView.vue?vue&type=template&id=053e8d9a&scoped=true"
import script from "./VoteRecognitionsView.vue?vue&type=script&lang=js"
export * from "./VoteRecognitionsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "053e8d9a",
  null
  
)

export default component.exports